import { formatName } from './purchase/parsePassenger';
import normalizeName from './normalizeName';
import normalizeFirstName from './normalizeFirstName';
import { adaptPassengersData } from './userPreferences';

/**
 * Normalizes name fields on a frequent passenger using the same rules as the passengers form.
 * @param {Object} passenger - Adapted frequent passenger object.
 * @returns {Object} Passenger with normalized name fields and computed `name`.
 */
export const normalizeFrequentPassengerNameFields = (passenger) => {
  const firstName = normalizeFirstName(passenger.firstName || '');
  const secondFirstName = passenger.secondFirstName
    ? normalizeFirstName(passenger.secondFirstName)
    : '';
  let lastName = normalizeName(passenger.lastName || '');
  let secondLastName = passenger.secondLastName ? normalizeName(passenger.secondLastName) : '';

  if (!lastName.trim() && secondLastName.trim()) {
    lastName = secondLastName;
    secondLastName = '';
  }

  return formatName({
    ...passenger,
    firstName,
    secondFirstName,
    lastName,
    secondLastName,
  });
};

/**
 * Adapts and normalizes frequent passengers from the recommendations API before they are shown or stored.
 * @param {Array<Object>|null|undefined} passengers - Raw frequent passengers from the API or Redux.
 * @returns {Array<Object>} Normalized frequent passenger objects.
 */
export const normalizeFrequentPassengersData = (passengers) => {
  if (!Array.isArray(passengers)) {
    return [];
  }

  return adaptPassengersData(passengers).map(normalizeFrequentPassengerNameFields);
};

export default normalizeFrequentPassengersData;
